// auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);
  private _roles: string[] = [];

  constructor() {}

  isLoggedIn(): boolean {
    return this.loggedIn.value;
  }

  getLoginStatus(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  setLoggedIn(status: boolean): void {
    this.loggedIn.next(status);
    if (!status) {
      this._roles = [];
    }
  }

  /** Kept for backward-compat — callers use .push() or direct access */
  get roles(): string[] {
    return this._roles;
  }
  set roles(value: string[]) {
    this._roles = value;
  }

  setRole(role: string): void {
    this._roles = [role];
  }

  getUserRoles(): string[] {
    return this._roles;
  }

  logout(): void {
    this.setLoggedIn(false);
  }
}
